import styled from "styled-components";

const FormContentContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  min-height: 50vh;
  width: 100%;
`;

export default FormContentContainer;
